import { render, staticRenderFns } from "./wRestaurant.vue?vue&type=template&id=5ef92fdf&scoped=true&"
import script from "./wRestaurant.vue?vue&type=script&lang=js&"
export * from "./wRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./wRestaurant.vue?vue&type=style&index=0&id=5ef92fdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef92fdf",
  null
  
)

export default component.exports